import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_API_URL;

// 创建 axios 实例
export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// API endpoints
export const API_ENDPOINTS = {
  GENERATE_HAIKU: '/api/generate',
  LIST_HAIKUS: '/api/haikus',
  GET_HAIKU: (id) => `/api/haikus/${id}`,
  RATE_HAIKU: (id) => `/api/haikus/${id}/rate`,
  COMMENT_HAIKU: (id) => `/api/haikus/${id}/comments`
};

// API 方法
export const apiService = {
  // 生成俳句
  generateHaiku: (prompt) => 
    api.post(API_ENDPOINTS.GENERATE_HAIKU, { prompt }),

  // 获取所有俳句
  listHaikus: () => 
    api.get(API_ENDPOINTS.LIST_HAIKUS),

  // 获取单个俳句
  getHaiku: (id) => 
    api.get(API_ENDPOINTS.GET_HAIKU(id)),

  // 评分俳句
  rateHaiku: (id, isLike) => 
    api.post(API_ENDPOINTS.RATE_HAIKU(id), { isLike }),

  // 添加评论
  commentHaiku: (id, comment) => 
    api.post(API_ENDPOINTS.COMMENT_HAIKU(id), { comment })
}; 